import React from 'react';
import './HowItWorksGraphic.css';

const steps = [
  {
    number: '1',
    label: <>Explore and<br />choose your<br />practitioner</>,
    title: 'Explore and Choose Your Practitioner',
  },
  {
    number: '2',
    label: <>Book<br />your<br />session</>,
    title: 'Book Your Session',
  },
  {
    number: '3',
    label: <>Experience<br />your<br />transformation</>,
    title: 'Experience Your Transformation',
  },
];

const Arrow = () => (
  <svg
    className="how-it-works-graphic__arrow"
    viewBox="0 0 112 64"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M4 15h59V2l45 30-45 30V49H4z" fill="currentColor" />
  </svg>
);

const HowItWorksGraphic = () => (
  <figure className="how-it-works-graphic" aria-label="How it works in three steps">
    <ol className="how-it-works-graphic__steps">
      {steps.map((step, index) => (
        <li className="how-it-works-graphic__step" key={step.number}>
          <div className="how-it-works-graphic__card">
            <span className="how-it-works-graphic__number" aria-hidden="true">
              {step.number}
            </span>
            <span className="how-it-works-graphic__label" aria-hidden="true">
              {step.label}
            </span>
            <span className="sr-only">{step.title}</span>
          </div>
          {index < steps.length - 1 && <Arrow />}
        </li>
      ))}
    </ol>
  </figure>
);

export default HowItWorksGraphic;
